import { render, staticRenderFns } from "./ProductDescLinks.vue?vue&type=template&id=218f340d&scoped=true&"
import script from "./ProductDescLinks.vue?vue&type=script&lang=js&"
export * from "./ProductDescLinks.vue?vue&type=script&lang=js&"
import style0 from "./ProductDescLinks.vue?vue&type=style&index=0&id=218f340d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218f340d",
  null
  
)

export default component.exports